import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=70e07c5b&scoped=true"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"
import style0 from "./RatingStar.vue?vue&type=style&index=0&id=70e07c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e07c5b",
  null
  
)

export default component.exports